import React, { PropsWithChildren } from 'react';
import { TooltipPlacement } from '../../../components/atoms/Tooltip';
import { ButtonType } from '../../../types/ButtonType';
import Btn, { BtnModifier } from '../../../components/molecules/Btn';
import { CollapsibleContent } from '../../../components/organisms/CollapsibleOverlay/CollapsibleOverlay';
import useCollapsibleOverlay from '../../../hooks/useCollapsibleOverlay';
import { CollapsibleModifier } from '../../../components/organisms/CollapsibleOverlay/CollapsibleOverlay.modifier';
import { SVGIcon } from '../../../components/atoms/SVG';

export type PageManagementCollapsibleActionsProps = PropsWithChildren<{
  icon: SVGIcon;
  title: string;
}>;
export function PageManagementCollapsibleActions({ icon, title, children }: PageManagementCollapsibleActionsProps) {
  const { collapsibleOpen, collapsibleProps, toggleProps } = useCollapsibleOverlay();
  return (
    <li className="pagemanagement__button-container">
      <Btn
        tooltipPlacement={TooltipPlacement.TOP}
        type={ButtonType.BUTTON}
        svgSpriteId={icon}
        text={title}
        titleText={title}
        hiddenText
        modifier={collapsibleOpen ? BtnModifier.ACTIVE : undefined}
        // do not use prop spreading for toggleProps: aria prop names are incompatible!
        onClick={toggleProps.onClick}
        onKeyDown={toggleProps.onKeyDown}
        reference={toggleProps.ref}
        ariaControls={toggleProps['aria-controls']}
        ariaExpanded={toggleProps['aria-expanded']}
      />
      {/* If there are no children, this component will not be rendered, because of this ul is never empty */}
      <CollapsibleContent {...collapsibleProps} modifier={CollapsibleModifier.PAGE_MANAGEMENT}>
        <ul className="pagemanagement__action-list pagemanagement__action-list--column">{children}</ul>
      </CollapsibleContent>
    </li>
  );
}
